module.exports = __webpack_public_path__ + "assets/sport-i-technologia.014cfba2.svg";